// extracted by mini-css-extract-plugin
module.exports = {"button":"cn","isRental":"co","lightBGPrimary":"cp","secondary":"cq","iconButton":"cr","darkBGSecondary":"cs","warning":"ct","outlined":"cu"};